import React from "react";

const DescriptionDropdown = ({ handleDescriptionValue, descDispValue, paidFree, selectedAccountRelatedTab }) => {
    
    const handleChangeDisposition = (e) => {
        const value = e.target.value;
        if (value !== "") {
            handleDescriptionValue(value);
        }
    };
    
    return (
        <>
            <select
                className="form-control"
                id="descDispValue"
                onChange={handleChangeDisposition}
            >
                <option selected value="">
                    {" "}
                    ---Select---
                </option>
                {descDispValue === undefined ? (
                    <></>
                ) : (
                    descDispValue.map((desc) => {
                        const isPaid = paidFree === "Paid | ";
                        const isOption427 = desc.GL_DISP_DESC_ID === "427";
                        const isOption428 = desc.GL_DISP_DESC_ID === "428";
                        const isOption333 = desc.GL_DISP_DESC_ID === "333";
                        const isHidden =
                            (!isPaid && isOption428) ||
                            (isPaid && isOption427) ||
                            (!isPaid && isOption333);
                        return (
                                <option
                                    key={desc.GL_DISP_DESC_ID}
                                    value={desc.GL_DISP_DESC_ID}
                                    style={{ display: isHidden ? "none" : "block" }}
                                >
                                    {desc.GL_DISP_DESC_NAME}
                                </option>
                        );
                    })
                )}
            </select>
        </>
    );
};

export default DescriptionDropdown;